import { render, staticRenderFns } from "./JoinTripModal.vue?vue&type=template&id=6ae387b2"
import script from "./JoinTripModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./JoinTripModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports